/* Keep the floating withdrawal trigger above the live consent panel on narrow screens.
   No cookie, consent, network, or withdrawal data is read or changed. */
(() => {
  'use strict';
  if (window.MaisonCookieMobileLayout) return;

  const mobile = window.matchMedia('(max-width: 600px)');
  const root = document.documentElement;
  const body = document.body;
  const bannerSelector = '[data-cookie-banner]';
  const triggerSelector = '#wbeu-trigger';
  let observedBanner;
  let observedTrigger;
  let resizeObserver;
  let frame = 0;

  function rendered(element) {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 &&
      element.getClientRects().length > 0;
  }

  function clearPlacement() {
    if (body.classList.contains('maison-cookie-trigger-relocated')) body.classList.remove('maison-cookie-trigger-relocated');
    if (root.style.getPropertyValue('--maison-cookie-trigger-bottom')) root.style.removeProperty('--maison-cookie-trigger-bottom');
  }

  function updatePlacement() {
    frame = 0;
    const banner = document.querySelector(bannerSelector);
    const trigger = document.querySelector(triggerSelector);
    if (observedBanner !== banner || observedTrigger !== trigger) {
      visibilityChanges.disconnect();
      for (const element of [banner, trigger]) {
        if (element) visibilityChanges.observe(element, { attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
      }
    }
    if (resizeObserver) {
      if (observedBanner && observedBanner !== banner) resizeObserver.unobserve(observedBanner);
      if (observedTrigger && observedTrigger !== trigger) resizeObserver.unobserve(observedTrigger);
      if (banner && observedBanner !== banner) resizeObserver.observe(banner);
      if (trigger && observedTrigger !== trigger) resizeObserver.observe(trigger);
    }
    observedBanner = banner;
    observedTrigger = trigger;

    if (!mobile.matches || !rendered(banner) || !rendered(trigger)) {
      clearPlacement();
      return;
    }

    const bannerTop = banner.getBoundingClientRect().top;
    const bottom = `${Math.ceil(Math.max(0, window.innerHeight - bannerTop + 12))}px`;
    if (root.style.getPropertyValue('--maison-cookie-trigger-bottom') !== bottom) {
      root.style.setProperty('--maison-cookie-trigger-bottom', bottom);
    }
    if (!body.classList.contains('maison-cookie-trigger-relocated')) {
      body.classList.add('maison-cookie-trigger-relocated');
    }
  }

  function schedulePlacement() {
    if (!frame) frame = window.requestAnimationFrame(updatePlacement);
  }

  const structureChanges = new MutationObserver(schedulePlacement);
  const visibilityChanges = new MutationObserver(schedulePlacement);
  structureChanges.observe(root, { subtree: true, childList: true });
  if (typeof ResizeObserver === 'function') resizeObserver = new ResizeObserver(schedulePlacement);
  window.addEventListener('resize', schedulePlacement);
  window.visualViewport?.addEventListener('resize', schedulePlacement);
  window.visualViewport?.addEventListener('scroll', schedulePlacement);
  mobile.addEventListener?.('change', schedulePlacement);
  schedulePlacement();

  window.MaisonCookieMobileLayout = Object.freeze({ refresh: schedulePlacement, destroy() {
    window.cancelAnimationFrame(frame);
    structureChanges.disconnect();
    visibilityChanges.disconnect();
    resizeObserver?.disconnect();
    window.removeEventListener('resize', schedulePlacement);
    window.visualViewport?.removeEventListener('resize', schedulePlacement);
    window.visualViewport?.removeEventListener('scroll', schedulePlacement);
    mobile.removeEventListener?.('change', schedulePlacement);
    clearPlacement();
    delete window.MaisonCookieMobileLayout;
  } });
})();
